/**************************************************
 * Nombre:       Seccion_Solicitudes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOSSOLICITUDES} from "../../Constantes";
import Dialogo_Soliciud from "../Dialogos/Dialogo_Soliciud";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import {arrConteoColMesesAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtras";


const Seccion_Solicitudes = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'solicitudes'})
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Soliciud,
        titulo: 'Detalles de la solicitud',
        realizado: cargarNuevamente
    })
    const [solicitudes, setSolicitudes] = useState([])
    const [solicitudesAnterior, setSolicitudesAnterior] = useState([])
    const [soliciudesTrasAnterior, setSoliciudesTrasAnterior] = useState([])
    const [estados, setEstados] = useState([])

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    const obtenerDatos = async () => {


        //  let arrHabitaciones = await obtenerHabitaciones()
        let fecha_ = new Date()


        let yearAcutual = fecha_.getFullYear()


        /* let arrReservasOcupacionYearAnterior = await arrConteoColAnoAtrasSuma({
             coleccion: 'solicitudes',
             year: yearAcutual - 1,
             wheres: [],
             propiedad: 'numNoches',
             numHabitaciones: arrHabitaciones.length
         })
         setSolicitudesAnterior(arrReservasOcupacionYearAnterior)

         let arrReservasOcupacionYearTrasAnterior = await arrConteoColAnoAtrasSuma({
             coleccion: 'reservas',
             year: yearAcutual - 1,
             wheres: w,
             propiedad: 'numNoches',
             numHabitaciones: arrHabitaciones.length
         })
         setSoliciudesTrasAnterior(arrReservasOcupacionYearTrasAnterior)*/

        let arrSolicitudes = await arrConteoColMesesAtras({coleccion: 'solicitudes', mesesAtras: 12, wheres: []})
        setSolicitudes(arrSolicitudes)


        let origenes_ = await arrConteoColPropiedadEstados({
            coleccion: 'solicitudes',
            propiedad: 'estado',
            arrEstados: ESTADOSSOLICITUDES.map((it) => it.nombre),
            wheres: []
        })

        setEstados(origenes_)

    }


    useEffect(() => {
        obtenerDatos().then()
    }, []);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Solicitudes'}
                        subtitulo={'Ultimos 12 meses'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: new Date().getFullYear(),
                                    data: solicitudes.map((it) => it.cantidad)

                                }
                            ]
                        }
                        labels={solicitudes.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Origen'}
                        subtitulo={'de reservas'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={20}
                        height={altoGraficas - 40}
                        series={
                            [{
                                name: 'Reservas',
                                data: estados.map((e) => e.cantidad)
                            }]
                        }

                        labels={estados.map((e) => e.nombre)}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de solicitudes'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Solicitudes

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
    {
        nombre: 'Pais',
        direccion: 'desc',
        propiedad: 'pais'
    },
]


const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Pais',
        direccion: 'left',
        propiedad: 'pais',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Negocio',
        direccion: 'left',
        propiedad: 'negocio',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSSOLICITUDES
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]